import styled from 'styled-components';

const SectionHeader = styled.span`
  position: relative;
  display: inline-block;
  margin-bottom: 10px;
  font-weight: 300;
  font-size: 18px;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.075em;
  color: #4c525a;
`;

SectionHeader.defaultProps = {
  style: {},
  size: null,
};

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/text/SectionHeader/index.js